import './i18next.d'
import type { EN } from './translations/en'
import type { I18Key } from '@w/fe-i18n-utils'
import { initI18n as initI18nUtils } from '@w/fe-i18n-utils'
import { namespaces } from './translations/namespaces'

export function initI18n() {
  initI18nUtils({
    namespaces,
    detection: {
      lookupLocalStorage: 'mwpreferredlanguage',
    },
    languages: {
      de: () => import('./translations/de/index'),
      en: () => import('./translations/en/index'),
    },
  })
}

export const i18Key = (key: I18Key<EN>): I18Key<EN> => key
export type FeInvI18nKey = I18Key<EN>

export { i18t, setLocale, i18tArgs } from '@w/fe-i18n-utils'
